import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueMeta from 'vue-meta'

// import VueCompositionAPI from '@vue/composition-api'

import 'bootstrap'
import Loading from 'vue-loading-overlay' // 瀏覽樣式
import 'vue-loading-overlay/dist/vue-loading.css' // 瀏覽的ccs樣式
import VueTelInput from 'vue-tel-input' // 國際電話
import VueSweetalert2 from 'vue-sweetalert2' //彈跳視窗
import 'sweetalert2/dist/sweetalert2.min.css'
import VeeValidate from 'vee-validate' // 表單驗證
import VueI18n from 'vue-i18n'
import zhTW from 'vee-validate/dist/locale/zh_TW'
import vi from 'vee-validate/dist/locale/vi'
import en from 'vee-validate/dist/locale/en'
import VueCookies from 'vue-cookies'
// import VueAnalytics from 'vue-analytics'

import VueCropper from 'vue-cropper'
import CKEditor from 'ckeditor4-vue'
import Element from 'element-ui'

// import signalr from '../src/store/signalR.js'

// import store from '../src/store/index.js'
import PG from '../src/store/plugin.js'
Vue.mixin(PG.mixin)
// Vue.use(signalr)

Vue.use(Element)
Vue.use(CKEditor)
Vue.use(VueCropper)

// Vue.use(VueCompositionAPI)

Vue.use(VueAxios, axios)
Vue.use(VueMeta)
Vue.use(VueTelInput)
Vue.use(VueSweetalert2)
Vue.use(VueI18n)
Vue.use(VueCookies)

const i18n = new VueI18n({
  locale: 'zhTW',
})

Vue.use(Loading, {
  // props
  width: 16,
  height: 16,
  backgroundColor: '#00DB00',
  opacity: 1,
  zIndex: 999,
  canCancel: false,
  color: '#00DB00',
})

Vue.component('Loading', Loading) // 全域啟用瀏覽中loading的樣式

// import './bus' // 將bus.vue直接掛在Vue主元件的下面

Vue.use(VeeValidate, {
  events: 'input|blur',
  validity: true,
  aria: true,
  i18n,
  dictionary: {
    zhTW,
    en,
    vi,
  },
})

new Vue({
  router,
  store,
  PG,
  i18n,
  render: (h) => h(App),
}).$mount('#app')

// Vue.use(VueAnalytics, {
//   id: 'UA-2062499-1',
//   router,
// })

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }

  if (to.meta.requiresAuth) {
    let getCookie = VueCookies.get('as')
    if (getCookie) {
      const api = `https://www.chanchao.com.tw/apiLogin2/isAuthenticated`
      const info = null

      Vue.axios
        .post(api, info, {
          headers: {
            as: getCookie,
          },
        })
        .then((response) => {
          if (response.data == 200) {
            sessionStorage.setItem('access', '200')
            next()
          } else {
            //251 的狀態
            sessionStorage.setItem('access', '')
            sessionStorage.removeItem('access')
            next({
              path: '/Landing',
            })
          }
        })
    } else {
      sessionStorage.setItem('access', '')
      sessionStorage.removeItem('access')
      next({
        path: '/Landing',
      })
    }
  } else {
    next()
  }
})
